import { action } from '@play-co/replicant';
import createActions from '../../config/actions/createActions';
import { type PromoGroupConfig, type PromoGroupItem } from './promoGroup.types';
import { promoGroupConfig } from './promoGroup.ruleset';
import { isGroupItemReady } from './promoGroup.getters';
import { setGroupItemSeen } from './promoGroup.modifiers';
import { createReportableError } from '../../utils/errors';

export const promoGroupActions = createActions({
  /**
   * Resolves a group item for its configured recurrence period.
   *
   * Show-resolved items call this after display. Action-resolved items call it
   * only after existing feature state proves the required action occurred.
   * Repeated resolution during the same period is an idempotent no-op.
   */
  groupItemWasResolved: action((state, item: PromoGroupItem, api) => {
    const now = api.date.now();

    // Repeated resolution during the same recurrence period changes nothing.
    if (!isGroupItemReady(state, item, now)) return;

    const { groupId, itemId } = item;
    const groupConfig: PromoGroupConfig = promoGroupConfig[groupId];
    const itemConfig = groupConfig.items.find((item) => item.id === itemId);

    if (!itemConfig) {
      api.reportError(
        createReportableError(
          'warning',
          new Error(`Group item config not found for ${groupId}:${itemId}`),
        ),
        { groupId, itemId },
      );
      return;
    }

    // Persist the resolution using the shared promo group item ledger.
    const eventId = itemConfig.eventID?.(state, now);
    setGroupItemSeen(state, item, now, eventId);
  }),
});
